module.exports = __webpack_public_path__ + "assets/chart.a8b3ec61.svg";